module.exports = __webpack_public_path__ + "img/traveler.121af719.svg";